import { Toaster } from 'sonner';

import { CartProvider } from '@frontend/storefront/components/cart/cart-context';
import { Navbar } from '@frontend/storefront/components/layout/navbar/index';
import {
  type StorefrontData,
  StorefrontDataContext,
} from '@frontend/storefront/data';
import Collection from '@frontend/storefront/pages/Collection';
import Home from '@frontend/storefront/pages/Home';
import Page from '@frontend/storefront/pages/Page';
import PageLayout from '@frontend/storefront/pages/PageLayout';
import Product from '@frontend/storefront/pages/Product';
import Search from '@frontend/storefront/pages/Search';
import SearchLayout from '@frontend/storefront/pages/SearchLayout';

export function Storefront({ data }: { data: StorefrontData }) {
  return (
    <StorefrontDataContext.Provider value={data}>
      <CartProvider>
        <Navbar />
        <main>
          {data.path === '/' ? (
            <Home />
          ) : data.product ? (
            <Product />
          ) : data.page ? (
            <PageLayout>
              <Page />
            </PageLayout>
          ) : data.notFound ? (
            <PageLayout>
              <h1 className="text-4xl">Page not found</h1>
              <a href="/">Back to nopad</a>
            </PageLayout>
          ) : (
            <SearchLayout>
              {data.path === '/search' ? <Search /> : <Collection />}
            </SearchLayout>
          )}
          <Toaster closeButton />
        </main>
      </CartProvider>
    </StorefrontDataContext.Provider>
  );
}
